import type { SelectorObject } from '@/types/hubspot';

export const experienceItems : Record<string, SelectorObject> = {
  "1": {
    label: "大学（法学部） 在学中／卒業",
    value: 1,
    hubspot_name: "university-faculty-of-Law-student-graduates",
  },
  "2": {
    label: "法科大学院 在学中／卒業",
    value: 2,
    hubspot_name: "law-school-students-graduates",
  },
  "3": {
    label: "司法試験予備試験 受験経験あり",
    value: 3,
    hubspot_name: "has-taken-the-preliminary-examination",
  },
  "4": {
    label: "司法試験 受験経験あり",
    value: 4,
    hubspot_name: " has-taken-the-bar-exam",
  },
  "5": {
    label: "法務部員経験あり",
    value: 5,
    hubspot_name: "experienced-legal-staff",
  },
  "0": {
    label: "法律学習経験／実務経験なし",
    value: 0,
    hubspot_name: "no-experience",
  },
};
export const eraItems : Record<string, SelectorObject> = {
  "20":{
    label: '20歳代',
    value: 20,
    hubspot_name: "20s",
  },
  "30":{
    label: '30歳代',
    value: 30,
    hubspot_name: "30s",
  },
  "40":{
    label: '40歳代',
    value: 40,
    hubspot_name: "40s",
  },
  "50":{
    label: '50歳以降',
    value: 50,
    hubspot_name: "50s-and-later",
  },
};
